import {
  AffordabilityMet,
  ISortOption,
  OutcomeResults,
  SortOrder,
  YesNoResults,
} from '@shared/models';

export const outcomeList: ISortOption[] = [
  {
    value: OutcomeResults.Yes,
    label: 'yes',
    svgIcon: 'checkmark',
    svgClass: 'svg-24 text-colour-green-600',
    svgFill: true,
  },
  { value: OutcomeResults.No,
    label: 'no',
    svgIcon: 'close',
    svgClass: 'svg-24 text-colour-red-600',
    svgFill: true,
  },
  {
    value: OutcomeResults.Refer,
    label: 'refer',
  },
  { value: OutcomeResults.Unset,
    label: 'restricted',
  },
];

export const igniteSortOptions: ISortOption[] = [
  { value: SortOrder.Ascending, label: 'Low to high', icon: 'fa-sort-numeric-up-alt fas', iconColour: 'text-dark' },
  {
    value: SortOrder.Descending, label: 'High to low', icon: 'fa-sort-numeric-down-alt fas', iconColour: 'text-dark',
  },
];

export const productsMatched: ISortOption[] = [
  {
    value: YesNoResults.Yes,
    label: 'yes',
    svgIcon: 'checkmark',
    svgClass: 'svg-24 text-colour-green-600',
    svgFill: true,
  },
  {
    value: YesNoResults.No,
    label: 'no',
    svgIcon: 'close',
    svgClass: 'svg-24 text-colour-red-600',
    svgFill: true,
  },
];

export const affordabilityMatched: ISortOption[] = [
  {
    value: AffordabilityMet.Yes,
    label: 'yes',
    svgIcon: 'checkmark',
    svgClass: 'svg-24 text-colour-green-600',
    svgFill: true,
  },
  {
    value: AffordabilityMet.No,
    label: 'no',
    svgIcon: 'close',
    svgClass: 'svg-24 text-colour-red-600',
    svgFill: true,
  },
  {
    value: AffordabilityMet.Unknown,
    label: 'no result',
  },
];
